import { render } from "./Defaults.vue?vue&type=template&id=6d315378"
import script from "./Defaults.vue?vue&type=script&lang=ts"
export * from "./Defaults.vue?vue&type=script&lang=ts"
script.render = render

export default script